var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('div',{staticClass:"footer-text"},[_c('div',{staticClass:"black thank_you"},[_vm._v("Thank you for doing business with us!")]),_c('div',{staticClass:"black support"},[_vm._v(" Our Support team is available from 9am - 12am everyday to "),_c('br'),_vm._v(" give you all round support; should you need any. ")])])])
}]

export { render, staticRenderFns }